import { render, staticRenderFns } from "./ProgramListView.vue?vue&type=template&id=ed7a0ba0"
import script from "./ProgramListView.vue?vue&type=script&lang=js"
export * from "./ProgramListView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports